import { Box, Container, Stack } from "@mui/material";

import { useIsFeatureEntitled } from "../../../Context/TierProvider";
import { useTrackFsk8sEventOnce, useTrackKubernetesLensEventOnce } from "../events";
import { Faq } from "./Faq";
import { GetStarted } from "./GetStarted";
import { Overview } from "./Overview";

const interSectionSpacing = 6;
const maxWidth = 1200;

export type K8sUpsellMode = "perfectscale" | "lens";

interface Fsk8sUpsellProps {
  mode?: K8sUpsellMode;
}

const Fsk8sUpsell = ({ mode = "perfectscale" }: Fsk8sUpsellProps) => {
  const customerHasEntitlement = useIsFeatureEntitled("lens:k8s");

  useTrackKubernetesLensEventOnce({
    condition: mode === "lens",
    name: "Upsell Page Viewed",
    properties: {},
  });

  useTrackFsk8sEventOnce({
    condition: mode === "perfectscale",
    name: "Upsell Page Viewed",
    properties: {},
  });

  return (
    <>
      <Container>
        <Box
          sx={{
            maxWidth,
            mb: interSectionSpacing,
            mx: "auto",
            mt: 8,
          }}
        >
          <Stack spacing={6}>
            <Overview mode={mode} />
            {customerHasEntitlement && mode === "lens" && <GetStarted />}
          </Stack>
        </Box>
      </Container>
      <Box
        width="100%"
        sx={{
          // Undo MainLayout default padding
          mb: "-80px",
          pb: "80px",

          px: 2,
          pt: interSectionSpacing,
          backgroundColor: "general.backgroundDark",
        }}
      >
        <Box sx={{ mx: "auto", maxWidth }}>
          <Faq mode={mode} />
        </Box>
      </Box>
    </>
  );
};

export default Fsk8sUpsell;
